module.exports = __webpack_public_path__ + "static/media/logo.b66aa80f.png";